import { render, staticRenderFns } from "./Proceding.vue?vue&type=template&id=25347118&scoped=true&"
import script from "./Proceding.vue?vue&type=script&lang=js&"
export * from "./Proceding.vue?vue&type=script&lang=js&"
import style0 from "./Proceding.vue?vue&type=style&index=0&id=25347118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25347118",
  null
  
)

export default component.exports